<template>
  <PrimeModal
    v-if="is_open"
    :is_small="false"
    :is_medium="true"
    :hide_maximize_button="true"
    @action-primary="openIntercom"
    @update:visible="is_open = false"
  >
    <template #title>{{ $t('project.labels.limitReached') }}</template>
    <template #content>
      <div
        data-test="project-limit-reached"
        class="mx-auto flex max-w-3xl flex-col items-center gap-6 rounded-lg border-2 border-primary-500 bg-orange-50 p-8 py-4"
      >
        <div class="flex flex-col items-center justify-center gap-4 sm:flex-row sm:items-center">
          <div class="shrink-0">
            <img
              class="h-32 w-32 object-contain sm:h-40 sm:w-40"
              :src="Ziggy_laptop"
              alt="Ziggy with laptop"
            />
          </div>
          <div class="flex flex-1 flex-col justify-center gap-2 text-center sm:text-left">
            <p class="font-medium text-surface-700">
              {{ $t('project.labels.outOfProjects') }}
            </p>
            <p class="text-sm text-surface-600">
              {{ $t('project.labels.outOfProjectsContact') }}
            </p>
          </div>
        </div>
      </div>
    </template>
    <template #ButtonPrimary>{{ $t('modal.actions.contact_ziggu') }}</template>
  </PrimeModal>
</template>

<script setup>
import PrimeModal from '@/app/shared_components/modals/ThePrimeModal.vue';
import Ziggy_laptop from '@/assets/images/ziggy/Ziggy_laptop.png';

const is_open = defineModel({ type: Boolean });

function openIntercom() {
  window.Intercom('show');
  is_open.value = false;
}
</script>
